import { styled } from '@mui/material';

export const Container = styled('div')(() => ({
  display: 'inline-flex',
  width: '100%',
}));

export const FilterButton = styled('button')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  width: '100%',
  color: theme.colors.primaryText,
  backgroundColor: theme.colors.background,
  margin: 0,
  padding: `${theme.spacings.unit(1)} ${theme.spacings.unit(0)}`,
  borderTop: 'transparent',
  borderRight: `1px solid ${theme.colors.paragraphText}`,
  borderBottom: `1px solid ${theme.colors.paragraphText}`,
  borderLeft: 'transparent',
  outline: 'none',
  cursor: 'pointer',
  fontSize: theme.fonts.utility.size(7),
}));

export const FilterButtonContent = styled('span')(({ theme }) => ({
  marginLeft: theme.spacings.unit(2),
}));
